import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import './ManagePolicyContent.css';
import InputControl from '../../Components/Common/TextField/TextField';
import DropDown from '../../Components/Common/DropDown/DropDown';
import Button from '../../Components/Button/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {GetAdminGroupsByUPN, GetAllFormLabels, SavePolicy } from '../../Reducers/dcoi';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { Spinner } from '@microsoft/mgt-react';
import QuillEditor from '../../Components/Common/QuillEditor/QuillEditor';
import Toster from '../../Components/Common/Toster/Toster';
import "./ManagePolicyContent.css";

function ManagePolicyContent() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const policyData = location?.state?.policyData || {};
  const { policiesListByUPN, languageList, inProgress } = useSelector((state) => state.dcoi);


const [savirity,setSavirity]=useState();
const [message,setMessage]=useState();
const[alert,setAlert]=useState(false);
  const [language, setLanguage] = useState(policyData?.FormLabelId || '');
  const [policyTitle, setPolicyTitle] = useState(policyData?.Title || '');
  const [policyHtml, setPolicyHtml] = useState(policyData?.Content || '');
  const [privacyTitle, setPrivacyTitle] = useState(policyData?.PrivacyNoticeTitle || '');
  const [privacyHtml, setPrivacyHtml] = useState(policyData?.PrivacyNoticeContent || '');
  const [afaTitle, setAfaTitle] = useState(policyData?.AFATitle || '');
  const [afaHtml, setAfaHtml] = useState(policyData?.AFAContent || '');
  const [entityAdmin, setEntityAdmin] = useState(policyData?.UserGroupId || '');
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    dispatch(GetAdminGroupsByUPN());
    dispatch(GetAllFormLabels());
  }, [dispatch]);

  useEffect(() => {
    const isFormValid =
      entityAdmin &&
      language &&
      policyTitle &&
      policyHtml?.trim() !== "" && // Ensure Quill Editor has content
      privacyTitle &&
      privacyHtml?.trim() !== "" &&
      afaTitle &&
      afaHtml?.trim() !== "";
  
    setIsDisabled(!isFormValid); // Disable if form is incomplete
  }, [entityAdmin, language, policyTitle, policyHtml, privacyTitle, privacyHtml, afaTitle, afaHtml]);
  

  const validateFields = () => {
    let errors = {};
    if (!entityAdmin) errors.entityAdmin = "Entity Admin Group is required.";
    if (!language) errors.language = "Language selection is required.";
    if (!policyTitle) errors.policyTitle = "Policy Title is required.";
    if (!policyHtml) errors.policyHtml = "Policy Content is required.";
    if (!privacyTitle) errors.privacyTitle = "Privacy Notice Title is required.";
    if (!privacyHtml) errors.privacyHtml = "Privacy Notice Content is required.";
    if (!afaTitle) errors.afaTitle = "AFA Title is required.";
    if (!afaHtml) errors.afaHtml = "AFA Content is required.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePolicyChange = (content) => {
    setPolicyHtml(content.trim() === "<p><br></p>" ? "" : content); 
  };
  
  const handlePrivacyChange = (content) => {
    setPrivacyHtml(content.trim() === "<p><br></p>" ? "" : content);
  };
  
  const handleAfaChange = (content) => {
    setAfaHtml(content.trim() === "<p><br></p>" ? "" : content);
  };


  const handleSubmit = () => {
    if (!validateFields()) return;
    const payload = {
      Id:policyData?.ID,
      GroupId: entityAdmin,
      LanguageID: language,
      PolicyTitle: policyTitle,
      CreatePolicy: policyHtml,
      PrivacyNoticeTitle: privacyTitle,
      PrivacyNoticeContent: privacyHtml,
      AFATitle: afaTitle,
      AFAContent: afaHtml,
    };
    try {
      dispatch(SavePolicy(payload)).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setTimeout(()=>{
            navigate(`/app-dcoi/sitecontent/ManagePolicyContentHome`);
          },1000)
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setSavirity("error");
          setMessage(res?.payload?.data[0]?.error)
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSavirity("error");
        }
      })
    } catch {
      setAlert(true);
      setSavirity("error");
      setMessage(`Something went wrong..`)
    }
    
  };

  return (
    <>
    <Toster message={message} severity={savirity} alert={alert} setAlert={setAlert} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
          {policyData?.ID ? 'Edit Policy Content' : 'Add Policy Content'}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{ color: " #212129",display:'flex',alignItems:"center", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
            onClick={() => navigate(`/app-dcoi/sitecontent/ManagePolicyContentHome`)}
          >
            <ArrowBackIos sx={{ fontSize: "inherit" }} /> Back to List
          </Typography>
        </Box>
      </div>

      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={6}>
            <Typography sx={{ fontWeight: "bold" }}>Entity Admin Group <span className='required'>*</span></Typography>
            <DropDown placeholder="--Select Group--" options={policiesListByUPN} value={entityAdmin} onChange={setEntityAdmin} />
            {errors.entityAdmin && <Typography color="error">{errors.entityAdmin}</Typography>}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ fontWeight: "bold" }}>Select Language <span className='required'>*</span></Typography>
            <DropDown placeholder="--Select Language--" options={languageList} value={language} onChange={setLanguage} />
            {errors.language && <Typography color="error">{errors.language}</Typography>}
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Policy Title <span className='required'>*</span></Typography>
          <InputControl  placeholder="E.g: Publicis EN, Starcom NL, ..." disabled={policyData?.ID ? true : false} value={policyTitle} onChange={setPolicyTitle} />
          {errors.policyTitle && <Typography color="error">{errors.policyTitle}</Typography>}
        </Grid>
        <Grid item xs={12} sm={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Create Policy <span className='required'>*</span></Typography>
          <QuillEditor value={policyHtml} onChange={handlePolicyChange} placeholder="" />
          {errors.policyHtml && <Typography color="error">{errors.policyHtml}</Typography>}
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Privacy Notice Title <span className='required'>*</span></Typography>
          <InputControl placeholder="E.g: Privacy Notice Template for the use of the Digital Conflict of Interest (“DCOI”) web application" value={privacyTitle} onChange={setPrivacyTitle} />
          {errors.privacyTitle && <Typography color="error">{errors.privacyTitle}</Typography>}
        </Grid>
        <Grid item xs={12} sm={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Privacy Notice Content <span className='required'>*</span></Typography>
          <QuillEditor value={privacyHtml} onChange={handlePrivacyChange} />
          {errors.privacyHtml && <Typography color="error">{errors.privacyHtml}</Typography>}
        </Grid>

        <Grid item xs={12} sm={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>AFA Title <span className='required'>*</span></Typography>
          <InputControl placeholder="E.g: Politically exposed Person  (“DCOI”) web application" value={afaTitle} onChange={setAfaTitle} />
          {errors.afaTitle && <Typography color="error">{errors.afaTitle}</Typography>}
        </Grid>
        <Grid item xs={12} sm={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>AFA Content <span className='required'>*</span></Typography>
          <QuillEditor value={afaHtml} onChange={handleAfaChange} />
          {errors.afaHtml && <Typography color="error">{errors.afaHtml}</Typography>}
        </Grid>
      </Box>

      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} sx={{ margin: "20px", display: "flex", justifyContent: "center" }}>
        <Button 
  label={policyData?.ID ? "Update Policy" : "Save Policy"} 
  onClick={handleSubmit} 
  isDisabled={isDisabled} 
/>
          &nbsp;&nbsp;
          <Button label="Cancel" onClick={() => navigate('/app-dcoi/sitecontent/ManagePolicyContentHome')} />
        </Grid>
      </Grid>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManagePolicyContent;
